module.exports = __webpack_public_path__ + "img/cp-outlined-map.272b6af3.svg";